<template>
  <div class="profile-page">
    <v-dialog v-model="changePicDialog" width="400" persistent>
      <v-card class="rounded-xl">
        <v-layout wrap justify-center pa-4>
          <v-flex xs12>
            <div class="d-flex justify-space-between align-center mb-4">
              <h3 class="dialog-title">Update Profile Picture</h3>
              <v-btn icon @click="changePicDialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <EditPicture @stepper="winStepper" />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-container class="py-6 py-md-12">
      <v-layout wrap>
        <!-- Header Section -->
        <v-flex xs12 class="mb-8">
          <div class="header-section text-left">
            <h1 class="page-title">My Account</h1>
            <v-divider class="title-divider mt-2"></v-divider>
          </div>
        </v-flex>

        <!-- User Info Card -->
        <v-flex xs12 class="mb-10" v-if="appUser">
          <v-card flat class="user-info-card pa-6 pa-md-8 d-flex flex-column flex-sm-row align-center align-sm-start">
            <div class="avatar-container mb-4 mb-sm-0 mr-sm-8">
              <div class="avatar-wrapper">
                <v-img
                  v-if="appUser.image"
                  :src="mediaURL + appUser.image"
                  class="profile-avatar"
                >
                  <template v-slot:placeholder>
                    <div class="d-flex align-center justify-center fill-height">
                      <v-progress-circular indeterminate color="#3EA56E" size="30"></v-progress-circular>
                    </div>
                  </template>
                </v-img>
                <v-img v-else src="./../../assets/Images/noProfileImg.jpg" class="profile-avatar">
                   <template v-slot:placeholder><ImageLoader /></template>
                </v-img>
                
                <v-btn
                  v-if="$route.path == '/Profile/Edit'"
                  fab
                  x-small
                  color="#3EA56E"
                  dark
                  class="edit-avatar-btn"
                  @click="changePicDialog = true"
                >
                  <v-icon size="18">mdi-camera-outline</v-icon>
                </v-btn>
              </div>
            </div>

            <div class="user-details text-center text-sm-left flex-grow-1">
              <h2 class="user-name mb-1">{{ appUser.firstname }} {{ appUser.lastname }}</h2>
              <p class="user-email mb-4">{{ appUser.email }}</p>
              
              <v-btn
                v-if="$route.path !== '/Profile/Edit'"
                outlined
                color="#3EA56E"
                class="edit-profile-btn px-6"
                to="/Profile/Edit"
              >
                <v-icon left size="18">mdi-account-edit-outline</v-icon>
                Edit Profile
              </v-btn>
            </div>
            
            <div class="logout-container pt-4 pt-sm-0 ml-sm-auto">
               <v-btn text color="#ef4444" @click="appLogout" class="logout-btn">
                 <v-icon left>mdi-logout</v-icon>
                 Log Out
               </v-btn>
            </div>
          </v-card>
        </v-flex>

        <!-- Main Content Area -->
        <v-flex xs12>
          <v-layout wrap>
            <!-- Navigation Menu -->
            <v-flex xs12 md3 class="mb-6 mb-md-0">
              <v-card flat class="nav-menu-card overflow-hidden">
                <v-list class="pa-0">
                  <template v-for="(item, i) in navItems">
                    <v-list-item
                      :key="item.name"
                      :to="item.route"
                      link
                      exact
                      class="nav-list-item py-2"
                      active-class="active-nav-item"
                    >
                      <v-list-item-icon class="mr-4">
                        <v-icon size="22">{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="nav-item-title">{{ item.name }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="'div'+i" v-if="i < navItems.length - 1"></v-divider>
                  </template>
                </v-list>
              </v-card>
            </v-flex>

            <!-- View Area -->
            <v-flex xs12 md9 class="pl-md-8">
              <v-card flat class="content-view-card pa-6 pa-md-10 min-height-card">
                <router-view></router-view>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import EditPicture from "./editPicture";
export default {
  components: {
    EditPicture,
  },
  data() {
    return {
      changePicDialog: false,
      navItems: [
        { name: "My Profile", route: "/Profile", icon: "mdi-account-outline" },
        { name: "My Orders", route: "/Profile/Orders", icon: "mdi-package-variant-closed" },
        { name: "Wishlist", route: "/Profile/Wishlist", icon: "mdi-heart-outline" },
        { name: "My Cart", route: "/Profile/Cart", icon: "mdi-cart-outline" },
        { name: "Saved Addresses", route: "/Profile/SavedAddress", icon: "mdi-map-marker-outline" },
      ],
    };
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
  },
  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
    },
    winStepper(windowData) {
      if (windowData.ref == "close") {
        this.changePicDialog = windowData.changePicDialog;
      }
    },
  },
};
</script>

<style scoped>
.profile-page {
  background-color: #f8fafc;
  min-height: 100vh;
}

.page-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 28px;
  color: #2c3e50;
  text-transform: uppercase;
  text-align: left;
}

.title-divider {
  border-width: 1px;
  border-color: #e2e8f0 !important;
}

.user-info-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0 !important;
  border-radius: 16px;
}

.avatar-wrapper {
  position: relative;
  width: 120px;
  height: 120px;
}

.profile-avatar {
  border-radius: 12px;
  border: 4px solid #f1f5f9;
  width: 120px;
  height: 120px;
}

.edit-avatar-btn {
  position: absolute;
  bottom: -10px;
  right: -10px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
}

.user-name {
  font-family: "ibmsemibold", sans-serif;
  font-size: 24px;
  color: #1e293b;
}

.user-email {
  font-family: "sofialight", sans-serif;
  font-size: 16px;
  color: #64748b;
}

.edit-profile-btn {
  border-radius: 8px;
  font-family: "ibmsemibold", sans-serif;
  text-transform: none;
  font-size: 14px;
}

.logout-btn {
  font-family: "ibmsemibold", sans-serif;
  text-transform: none;
  letter-spacing: 0.5px;
}

.nav-menu-card {
  border: 1px solid #e2e8f0 !important;
  border-radius: 16px;
  background-color: #ffffff;
}

.nav-list-item {
  transition: all 0.2s ease;
}

.active-nav-item {
  background-color: #f0faf4 !important;
  color: #3EA56E !important;
}

.active-nav-item .v-icon {
  color: #3EA56E !important;
}

.nav-item-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 15px;
  color: #475569;
  text-align: left;
}

.active-nav-item .nav-item-title {
  color: #3EA56E;
}

.content-view-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0 !important;
  border-radius: 16px;
}

.min-height-card {
  min-height: 500px;
}

.dialog-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 18px;
  color: #1e293b;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 22px;
  }
  
  .avatar-wrapper {
    width: 100px;
    height: 100px;
  }
  
  .profile-avatar {
    width: 100px;
    height: 100px;
  }
  
  .user-name {
    font-size: 20px;
  }
}
</style>